import { I18nPluralPipe, NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output,
} from '@angular/core';
import {
    DialogButtonComponent,
    DialogButtonsComponent,
} from '@interacta-shared/ui';
import { IEditPostLinksResponse } from '@interacta/util-post';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'interacta-relations-dialog-link-results',
    templateUrl: './relations-dialog-link-results.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        DialogButtonComponent,
        DialogButtonsComponent,
        NgTemplateOutlet,
        I18nPluralPipe,
        TranslatePipe,
    ],
})
export class RelationsDialogLinkResultsComponent {
    linkResults = input.required<IEditPostLinksResponse>();

    back = output();
    readonly labelRoot = 'RELATIONS_DIALOG.LINK_RESULTS.';

    readonly linksSuccess = computed(() => this.linkResults().linksSuccess);
    readonly linksErrorValidation = computed(
        () => this.linkResults().linksErrorValidation,
    );
    readonly linksErrorConcurrency = computed(
        () => this.linkResults().linksErrorConcurrency,
    );
}
